import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useStore } from './store/useStore'
import ErrorBoundary from './components/ErrorBoundary'
import LoginPage from './pages/LoginPage'
import HomePage from './pages/HomePage'
import ProfilePage from './pages/ProfilePage'
import PublicProfilePage from './pages/PublicProfilePage'
import MyPersonaPage from './pages/MyPersonaPage'
import MatchesPage from './pages/MatchesPage'
import ChatPage from './pages/ChatPage'
import CommunityFeedPage from './pages/CommunityFeedPage'
import PostDetailPage from './pages/PostDetailPage'

// Import admin components
import AdminLayout from './components/AdminLayout'
import AdminLoginPage from './pages/admin/AdminLoginPage'
import AdminDashboard from './pages/admin/AdminDashboard'
import AdminUsersPage from './pages/admin/AdminUsersPage'
import AdminReportsPage from './pages/admin/AdminReportsPage'
import AdminLogsPage from './pages/admin/AdminLogsPage'
import AdminForcedMatchPage from './pages/admin/AdminForcedMatchPage'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user } = useStore()
  if (!user) {
    return <Navigate to="/login" replace />
  }
  return <>{children}</>
}


import { useEffect } from 'react'
import { api } from './lib/api'

function App() {
  const { token } = useStore()

  useEffect(() => {
    if (token) {
      api.setToken(token)
    }
  }, [token])

  return (
    <ErrorBoundary>
      <BrowserRouter>
        <div className="min-h-screen bg-base-200">
          <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<LoginPage />} />

          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="users" element={<AdminUsersPage />} />
            <Route path="forced-match" element={<AdminForcedMatchPage />} />
            <Route path="reports" element={<AdminReportsPage />} />
            <Route path="logs" element={<AdminLogsPage />} />
          </Route>

          {/* Protected User Routes */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <HomePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile/:userId"
            element={
              <ProtectedRoute>
                <PublicProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-persona"
            element={
              <ProtectedRoute>
                <MyPersonaPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/matches"
            element={
              <ProtectedRoute>
                <MatchesPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/chat/:matchId"
            element={
              <ProtectedRoute>
                <ChatPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/community"
            element={
              <ProtectedRoute>
                <CommunityFeedPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/community/:postId"
            element={
              <ProtectedRoute>
                <PostDetailPage />
              </ProtectedRoute>
            }
          />
          </Routes>
        </div>
      </BrowserRouter>
    </ErrorBoundary>
  )
}

export default App
